import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun TourAdminDisclosure(label: String, content: @Composable () -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    Div(attrs = { classes("tour-admin-details") }) {
        Button(attrs = { classes("tour-admin-disclosure-toggle"); type(ButtonType.Button); attr("aria-label", label); attr("aria-expanded", expanded.toString()); onClick { expanded = !expanded } }) {
            Span(attrs = { attr("aria-hidden", "true") }) { Text(if (expanded) "▾ " else "▸ ") }
            Text(label)
        }
        if (expanded) Div(attrs = { classes("tour-admin-disclosure-content") }) { content() }
    }
}

@Composable
internal fun TourAdminStatus(loading: Boolean, busy: Boolean, error: String?, loadingLabel: String, refreshLabel: String, refreshDisabled: Boolean = false, onRefresh: () -> Unit) {
    Div(attrs = { classes("tour-admin-status") }) {
        Div(attrs = { attr("aria-live", "polite") }) {
            if (loading) P { Text(loadingLabel) }
            else if (busy) P { Text("Ukládám…") }
            TourError(error)
        }
        Button(attrs = { if (busy || loading || refreshDisabled) disabled(); onClick { onRefresh() } }) { Text(refreshLabel) }
    }
}
